import styled from "@emotion/styled";
import type { StepLiquidityPool } from "@stepfinance/liquidity";
import { BaseButton } from "@stepfinance/react";
import type { NormalizedTokenAccount } from "@stepfinance/tokens";
import type { CollapsePanelProps } from "antd";
import { Collapse } from "antd";
import type { FC } from "react";

import { isLiquidityPoolUntrackable } from "../../utils/pools/utils";
import { PoolDataDisplay } from "./PoolDataDisplay";
import { PoolAmountSpan, PoolInfoHeader } from "./PoolInfoHeader";
import type { YourPoolsProps } from "./YourPools";

const { Panel: BasePanel } = Collapse;

type PoolPanelProps = Omit<CollapsePanelProps, "header"> &
  YourPoolsProps & {
    pool: StepLiquidityPool;
    accounts: NormalizedTokenAccount[];
  };

export const YourPoolsPanel: FC<PoolPanelProps> = ({ pool, accounts, onPoolLiquidityAction, ...props }) => {
  const hasUntrackableValue = isLiquidityPoolUntrackable(pool.liquidityInUSD);
  return (
    <Panel
      {...props}
      header={<YourPoolInfoHeader pool={pool} accounts={accounts} hasUntrackableValue={hasUntrackableValue} />}
    >
      <div className="panel-content">
        <PoolDataDisplay pool={pool} accounts={accounts} />
        <div className="panel-content-section">
          <div className="liquidity-button-spacer"></div>
          <LiquidityButton onClick={() => onPoolLiquidityAction?.("remove", pool)}>Remove Liquidity</LiquidityButton>
        </div>
      </div>
    </Panel>
  );
};

const YourPoolInfoHeader = styled(PoolInfoHeader)`
  padding: 30px 40px 30px 30px;
  user-select: none;
  width: 100%;
  border-radius: 8px;

  ${PoolAmountSpan} {
    margin-right: 30px;
    font-family: Space Mono;
  }
`;

const Panel = styled(BasePanel)`
  background-color: #202020;
  border-radius: 8px;

  .panel-content {
    padding: 0px 30px 30px 30px;
  }

  .panel-content-section {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }

  .liquidity-button-spacer {
    width: 10px;
  }
`;

const LiquidityButton = styled(BaseButton)`
  width: 100%;
  font-size: 10px;
`;
